import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, money, customText } from "../../lib/api";
import { downloadCsv } from "../../components/AdminLayout";

const STATUSES = [
  "ORDER RECEIVED", "PREORDER PENDING", "PREORDER CLOSED", "PRODUCTION PREPARATION",
  "IN PRODUCTION", "QUALITY CONTROL", "READY FOR FULFILLMENT", "READY TO SHIP",
  "SHIPPED", "READY FOR ACADEMY PICKUP", "COMPLETED", "CANCELLED", "REFUNDED",
];

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [channel, setChannel] = useState("");
  const [open, setOpen] = useState(null);

  const load = () => {
    const q = channel ? `?channel=${channel}` : "";
    api.get(`/admin/orders${q}`).then(({ data }) => setOrders(data)).catch(() => {});
  };
  useEffect(() => { load(); }, [channel]);

  const setStatus = async (id, status) => {
    try {
      await api.patch(`/admin/orders/${id}/status`, { status });
      toast.success("Status updated");
      load();
    } catch { toast.error("Update failed"); }
  };

  return (
    <div className="px-5 lg:px-8 py-8">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
        <div>
          <p className="font-mono text-yellow-400 uppercase tracking-widest text-xs">Order Management</p>
          <h1 className="font-heading font-black uppercase text-4xl text-white mt-1">Orders</h1>
        </div>
        <div className="flex gap-2">
          {["", "retail", "wholesale"].map((c) => (
            <button key={c || "all"} data-testid={`orders-filter-${c || "all"}`} onClick={() => setChannel(c)} className={`px-4 py-2 rounded-sm text-sm font-mono uppercase ${channel === c ? "bg-yellow-400 text-black" : "bg-[#121216] text-zinc-400 border border-white/10"}`}>
              {c || "All"}
            </button>
          ))}
          <button onClick={() => downloadCsv(api, "/admin/export/orders", "paragon_orders.csv")} className="btn-outline px-4 py-2 rounded-sm text-sm">Export CSV</button>
        </div>
      </div>

      <div className="bg-[#121216] border border-white/10 rounded-lg overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left font-mono text-[10px] uppercase tracking-widest text-zinc-500 border-b border-white/10">
              <th className="px-4 py-3">Order #</th><th className="px-4 py-3">Channel</th><th className="px-4 py-3">Customer</th>
              <th className="px-4 py-3">Academy</th><th className="px-4 py-3">Units</th><th className="px-4 py-3">Total</th><th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((o) => (
              <React.Fragment key={o.id}>
                <tr data-testid={`admin-order-${o.order_number}`} onClick={() => setOpen(open === o.id ? null : o.id)} className="border-b border-white/5 hover:bg-white/5 cursor-pointer">
                  <td className="px-4 py-3 font-mono text-yellow-400">{o.order_number}</td>
                  <td className="px-4 py-3"><span className={o.channel === "wholesale" ? "text-emerald-400" : "text-zinc-300"}>{o.channel}</span></td>
                  <td className="px-4 py-3 text-white">{o.customer_name}</td>
                  <td className="px-4 py-3 text-zinc-400">{o.academy_name || "—"}</td>
                  <td className="px-4 py-3 font-mono">{o.units}</td>
                  <td className="px-4 py-3 font-mono text-white">{money(o.total)}</td>
                  <td className="px-4 py-3" onClick={(e) => e.stopPropagation()}>
                    <select data-testid={`order-status-${o.order_number}`} value={o.status} onChange={(e) => setStatus(o.id, e.target.value)} className="bg-[#0A0A0C] border border-white/15 rounded px-2 py-1.5 text-xs text-white max-w-[160px]">
                      {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                    </select>
                  </td>
                </tr>
                {open === o.id && (
                  <tr className="bg-black/40"><td colSpan={7} className="px-4 py-4">
                    <div className="grid md:grid-cols-2 gap-4">
                      <div>
                        <p className="font-mono text-xs text-zinc-500 mb-1">Items</p>
                        {o.items.map((it, i) => (
                          <p key={i} className="text-sm text-white">{it.product_name} {it.color ? `· ${it.color}` : ""} <span className="font-mono text-xs text-zinc-500">{it.sizes.map((s) => `${s.size}×${s.qty}`).join(" ")}</span>{customText(it.customization) && <span className="block font-mono text-xs text-yellow-400">{customText(it.customization)}</span>}</p>
                        ))}
                      </div>
                      <div className="font-mono text-xs text-zinc-400 space-y-1">
                        <p>Email: {o.email}</p>
                        <p>Subtotal: {money(o.subtotal)} · Shipping: {money(o.shipping)} · Total: {money(o.total)}</p>
                        {o.production_cost_total != null && <p className="text-emerald-400">Production cost (internal): {money(o.production_cost_total)}</p>}
                        {o.notes && <p>Notes: {o.notes}</p>}
                      </div>
                    </div>
                  </td></tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
        {orders.length === 0 && <p className="text-zinc-600 font-mono text-sm p-8 text-center">No orders yet.</p>}
      </div>
    </div>
  );
}
